import { PartFinderBatch } from '@/api/generatedApi';
import { pluralize } from '@/utils/format';

export const getBatchLabel = (batch: Pick<PartFinderBatch, 'name' | 'sourceFilename' | 'breakdown'>): string =>
  batch.name ?? batch.sourceFilename ?? pluralize(batch.breakdown.total, 'part', 'parts');
